// FFs
export const FEEDBACK_PAGE_FF = 'learning_app_fe_feedback_page';
export const CHAMPIONS_PAGE_FF = 'community-champions-page';
export const CONTENT_ISSUE_BANNER_FF = 'content-issue-banner';
export const EMAIL_SUBSCRIPTION_FF = 'learning_app_fe_email_subscription';
export const COMMUNITY_ACCOUNT_SWITCHER_FF = 'community-account-switcher';
export const NEW_LEARNING_PATH_PAGE_FF = 'learning_app_fe_new_learning_path_page';
export const NEW_COURSE_PAGE_FF = 'learning_app_fe_new_course_page';
export const NEW_TOP_NAVIGATION_FF = 'community_new_top_navigation';
export const CONTENT_VERSIONING_FF = 'content_versioning';
export const ALM_INTEGRATION_FF = 'learning-alm-enabled';
export const ATLENZ_FF = 'atlenz_learning';
export const CONFLUENCE_HUB_FF = 'learning_app_fe-confluence_hub_enabled';
export const ENABLEMENT_ACADEMY_IN_ALP_FF = 'enablement-academy-in-alp';

export enum Environment {
  'DEVELOPMENT' = 'development',
  'STAGING' = 'staging',
  'PRODUCTION' = 'production',
  'LOCAL' = 'local',
}

//Hubs type
export enum AlternativeContentHubType {
  CERT_PREP = 'cert-prep',
  ROLE_BASED = 'role-based',
}

export enum AlternativeCollectionType {
  ROLE_BASED = 'role-based',
  CERT_PREP = 'cert-prep',
}

export enum LandingType {
  LIVE_TRAINING = 'live-training',
  CERTIFICATION_DETAIL = 'certification-detail',
}

export enum ContentHubType {
  ADOPTION_AND_CHANGE_MANAGEMENT = 'adoption-and-change-management',
  CERT_PREP = 'prepare-for-a-certification',
  ROLE_BASED = 'grow-your-career',
  LEARNING_PATHS = 'all-learning-paths',
  CERTIFICATIONS = 'certifications',
  RESOURCES_AND_SUPPORT = 'resources-and-support',
  ROVO = 'rovo',
  JIRA = 'jira',
  JIRA_CLOUD = 'jira-cloud',
  DYNAMIC = 'dynamic',
  CONFLUENCE = 'confluence',
  CONFLUENCE_CLOUD = 'confluence-data-center-to-cloud-adoption-guide',
}

export enum CollectionType {
  CERT_PREP = 'certification-prep',
  ROLE_BASED = 'career',
  TOPIC = 'topic',
  TEAM_TRAINING = 'team-training',
}

export enum ResourceType {
  SmLesson = 'lesson',
  SmCourse = 'course',
  LearningPath = 'learningPath',
  Collection = 'collection',
  Certification = 'certification',
  InstructorLedTraining = 'instructorLedTraining',
}

// Hostnames that should not have the /learning prefix
export const NO_URL_PREFIX_HOSTNAMES = [
  'learning.dev.atlassian.com',
  'learning.stg.atlassian.com',
  'academy.dev.atlassian.com',
  'academy.stg.atlassian.com',
];

// Consent-related constants
export const CONSENT_ERROR_PATH = '/user/error/consent-failed';
export const INITIALIZATION_ERROR_PATH = '/user/error/initialization-failed';
export const WELCOME_ILLUSTRATION_PATH = '/images/welcomeIllustration.png';

// Valid product names (camelCase format)
// Used for filtering and validating product tags across the application
export const VALID_PRODUCTS = [
  'atlas',
  'atlassian',
  'bamboo',
  'bitbucket',
  'clover',
  'compass',
  'confluence',
  'crowd',
  'crucible',
  'fisheye',
  'focus',
  'guard',
  'jira',
  'jiraAlign',
  'jiraProductDiscovery',
  'jiraServiceManagement',
  'loom',
  'opsgenie',
  'rovo',
  'sourcetree',
] as const;
